import React from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

const ApiDocs = () => {
  return (
    <div style={{ padding: '20px' }}>
      <SwaggerUI 
        url="/swagger/swagger.yaml" 
        customCss={".swagger-ui .topbar { display: none }"} 
      />
    </div>
  );
};

export default ApiDocs;
